<template>
  <div class="flex justify-center h-full items-center">
      <img src="../assets/loading.svg" alt="Loading">
  </div>
</template>

<script>
export default {

};
</script>

<style>

</style>
